import React from 'react';
import logo from 'assets/images/logo/Vaxschedhealthadult2024.png'
const AdultImmunizationSchedule = () => {
  const styles = {
    body: {
      fontFamily: 'Arial, sans-serif',
      // margin: '20px',
      // padding: '20px',
      backgroundColor: 'white'
    },
    container: {
      background: 'white',
      // padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'
    },
    img: {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '8px',
      marginTop: '10px'
    },
  }
  return (
    <div>
      <div style={styles.body}>
        <div className="container" style={styles.container}>
          <h1 style={{ color: '#333' }}>Adult Immunization Schedule by Medical Condition and Other Indications</h1>
          <h2 style={{ color: '#333' }}>Recommendations for Ages 19 Years or Older, United States, 2024</h2>

          <img src={logo} alt="brand-logo" width="max" style={styles.img} />
          <br />

          <div style={{ width: 'max', height: '1px', backgroundColor: 'black' }}></div>
          <br />

          <p>Administer recommended vaccines if vaccination history is incomplete or unknown. Do not restart or add doses
            to vaccine series if there are extended intervals between doses. The use of trade names is for
            identification purposes only and does not imply endorsement by the ACIP or CDC.</p>

          <h2 style={{ color: '#333' }}>NOTES</h2>
          <p>For vaccine recommendations for persons 18 years of age or younger, refer to the <a
            href="https://www.cdc.gov/vaccines/schedules/hcp/imz/child-adolescent.html" target="_blank" rel="noopener noreferrer">Recommended
            Child and Adolescent Immunization Schedule</a>.</p>

          <h2 style={{ color: '#333' }}>Additional Information</h2>
          <ul style={{ paddingLeft: '20px' }}>
            <li>For calculating intervals between doses, 4 weeks = 28 days. Intervals of ≥4 months are determined by
              calendar months.</li>
            <li>Within a number range (e.g., 12-18), a dash (–) should be read as "through."</li>
            <li>Vaccine doses administered ≤4 days before the minimum age or interval are considered valid. Doses of any
              vaccine administered ≥5 days earlier than the minimum age or minimum interval should not be counted as
              valid and should be repeated. <strong>The repeat dose should be spaced after the invalid dose by the
                recommended minimum interval.</strong></li>
            <li>Information on travel vaccination requirements and recommendations is available at <a
              href="https://www.cdc.gov/travel/" target="_blank" rel="noopener noreferrer">cdc.gov/travel/</a>.</li>
            <li>For vaccination of persons with immunodeficiencies, refer to Table 8-1, Vaccination of persons with
              primary and secondary immunodeficiencies, in <a
                href="https://www.cdc.gov/vaccines/hcp/acip-recs/general-recs/immunocompetence.html"
                target="_blank" rel="noopener noreferrer">General Best Practice Guidelines for Immunization</a>.</li>
            <li>For information about vaccination in the setting of a vaccine-preventable disease outbreak, contact your
              state or local health department.</li>
            <li>The National Vaccine Injury Compensation Program (VICP) is a no-fault alternative to the traditional
              legal system for resolving vaccine injury claims. All vaccines included in the adult immunization
              schedule except PPSV23, RSV, RZV, Mpox,
              and COVID-19 vaccines are covered by the National Vaccine Injury Compensation Program (VICP). Mpox and
              COVID-19 vaccines are covered by the Countermeasures Injury Compensation Program (CICP).
              For more information, refer to <a href="https://www.hrsa.gov/vaccinecompensation"
                target="_blank" rel="noopener noreferrer">VICP</a>.</li>
          </ul>

          <h2 style={{ color: '#333' }}>Polio Vaccination</h2>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p><strong> Routine Vaccination: Adults known or suspected to be unvaccinated or incompletely
                vaccinated:</strong> Administer
                remaining doses (1, 2, or 3 IPV doses) to complete a 3-dose primary series. (NOTE: Complete primary
                series
                consists of at least 3 doses of IPV or trivalent oral poliovirus vaccine [tOPV] in any combination.)
                Unless there are specific reasons to believe they were not vaccinated, most adults who were born and
                raised in the United States can assume they were vaccinated against polio as children.
              </p>
            </li>
          </ul>

          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p><strong> Special Situations: Adults at increased risk of exposure to poliovirus who have completed
                the primary series:</strong>
                (NOTE: Complete primary series consists of at least 3 doses of IPV or trivalent oral poliovirus
                vaccine [tOPV] in any combination): May administer one lifetime IPV booster.</p>
            </li>
            <li>
              <p>
                For detailed information, refer to <a
                  href="https://www.cdc.gov/vaccines/vpd/polio/hcp/recommendations.html"
                  target="_blank" rel="noopener noreferrer">www.cdc.gov/vaccines/vpd/polio/hcp/recommendations.html</a>.
              </p>
            </li>
          </ul>

          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p><strong> Contraindications and precautions:</strong>
                For contraindications and precautions to Poliovirus vaccine, inactivated (IPV), refer to <a
                  href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html#appendix-poliovirus"
                  target="_blank" rel="noopener noreferrer">
                  Poliovirus Appendix.</a>
              </p>
            </li>
          </ul>

          <div style={{ width: 'max', height: '1px', backgroundColor: 'black' }}></div>
          <br />

          <p><strong>HSCT:</strong> Hematopoietic stem cell transplant.</p>
          <p>* Precaution for LAIV4 does not apply to alcoholism.</p>
          <h3 style={{ color: '#333' }}>COVID-19 Vaccination</h3>
          <h4>Routine Vaccination:</h4>
          <p>Age 19 years or older:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Unvaccinated:
              <ul style={{ paddingLeft: '20px' }}>
                <li>1 dose of updated (2023-2024 Formula) Moderna or Pfizer-BioNTech vaccine.</li>
                <li>2-dose series of updated (2023-2024 Formula) Novavax at 0, 3-8 weeks.</li>
              </ul>
            </li>
            <li>Previously vaccinated with 1 or more doses of any COVID-19 vaccine:
              <ul style={{ paddingLeft: '20px' }}>
                <li>1 dose of any updated (2023-2024 Formula) COVID-19 vaccine administered at least 8 weeks after
                  the most recent COVID-19 vaccine dose.</li>
              </ul>
            </li>
          </ul>

          <h4>Special Situations:</h4>
          <p>Persons who are moderately or severely immunocompromised:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Unvaccinated:
              <ul style={{ paddingLeft: '20px' }}>
                <li>3-dose series of updated (2023-2024 Formula) Moderna at 0, 4, 8 weeks.</li>
                <li>3-dose series of updated (2023-2024 Formula) Pfizer-BioNTech at 0, 3, 7 weeks.</li>
                <li>2-dose series of updated (2023-2024 Formula) Novavax at 0, 3 weeks.</li>
              </ul>
            </li>
            <li>Previously vaccinated:
              <ul style={{ paddingLeft: '20px' }}>
                <li>Previously vaccinated with 1 dose of any Moderna: 2-dose series of updated (2023-2024 Formula)
                  Moderna at 0, 4 weeks (minimum interval between previous Moderna dose and dose 1: 4 weeks).</li>
                <li>Previously vaccinated with 2 doses of any Moderna: 1 dose of updated (2023-2024 Formula) Moderna
                  at least 4 weeks after most recent dose.</li>
                <li>Previously vaccinated with 1 dose of any Pfizer-BioNTech: 2-dose series of updated (2023-2024
                  Formula) Pfizer-BioNTech at 0, 4 weeks (minimum interval between previous Pfizer-BioNTech dose
                  and dose 1: 3 weeks).</li>
                <li>Previously vaccinated with 2 doses of any Pfizer-BioNTech: 1 dose of updated (2023-2024 Formula)
                  Pfizer-BioNTech at least 4 weeks after most recent dose.</li>
                <li>Previously vaccinated with 3 or more doses of any Moderna or Pfizer-BioNTech: 1 dose of any
                  updated (2023-2024 Formula) COVID-19 vaccine at least 8 weeks after the most recent dose.</li>
                <li>There is no preferential recommendation for the use of one COVID-19 vaccine over another when
                  more than one recommended
                  age-appropriate vaccine is available.</li>
                <li>
                  Current COVID-19 vaccine information available at <a href="https://www.cdc.gov/covidschedule"
                    target="_blank" rel="noopener noreferrer">www.cdc.gov/covidschedule</a>.
                  For information on Emergency Use Authorization(EUA) indications for COVID-19 vaccines, refer to
                  <a href="https://www.fda.gov/emergency-preparedness-and-response/coronavirus-disease-2019-covid-19/covid-19-vaccines"
                    target="_blank" rel="noopener noreferrer">
                    www.fda.gov/emergency-preparedness-and-response/coronavirus-disease-2019-covid-19/covid-19-vaccines</a>.
                </li>
                <li>*** Previously vaccinated is defined as having received any Original monovalent or bivalent
                  COVID-19 vaccine
                  (Janssen, Moderna, Novavax, Pfizer-BioNTech) prior to the updated 2023-2024 formulation.</li>
                <li>¶¶¶ Persons who are moderately or severely immunocompromised have the option to receive one
                  additional dose of updated
                  (2023-2024 Formula) COVID-19 vaccine at least 2 months following the last recommended updated
                  (2023-2024 Formula) COVID-19
                  vaccine dose. Further additional updated (2023-2024 Formula) COVID-19 vaccine dose(s) may be
                  administered, informed by the clinical
                  judgement of a health care provider and personal preference and circumstances. Any further
                  additional doses should be administered
                  at least 2 months after the last updated (2023-2024 Formula) COVID-19 vaccine dose.</li>
              </ul>
            </li>
            <li>
              Contraindications and precautions:

              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  For contraindications and precautions to COVID-19 vaccination, refer to <a
                    href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html#appendix-poliovirus"
                    target="_blank" rel="noopener noreferrer">
                    COVID-19 Appendix.</a>
                </li>
              </ul>
            </li>

          </ul>



          <h3 style={{ color: '#333' }}>Influenza Vaccination</h3>
          <p><strong>Routine Vaccination:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Age 19 years or older:1 dose any influenza vaccine appropriate for age and health status annually.</li>
            <li>Age 65 years or older: Any one of quadrivalent high-dose inactivated influenza vaccine (HD-IIV4),
              quadrivalent recombinant influenza vaccine (RIV4), or quadrivalent adjuvanted inactivated influenza
              vaccine (aIIV4) is preferred. If none of these three vaccines is available, then any other
              age-appropriate influenza vaccine should be used.</li>
            <li>For the 2023-2024 season, refer to <a href="https://www.cdc.gov/mmwr/volumes/72/rr/rr7202a1.htm."
              target="_blank" rel="noopener noreferrer">
              www.cdc.gov/mmwr/volumes/72/rr/rr7202a1.htm.</a></li>
            <li>For the 2023-2024 season, refer to the 2024-2025 ACIP influenza vaccine recommendations.</li>
          </ul>

          <p><strong>Special Situations:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Close contacts (e.g., caregivers, health care workers) of severely immunosuppressed persons who require
              a protected environment: Should not receive LAIV4. If LAIV4 is given, they should avoid contact
              with/caring for such immunosuppressed persons for 7 days after vaccination.
              is given, they should avoid contact with/caring for such immunosuppressed persons for 7 days after
              vaccination.</li>
            <li>Persons with an egg allergy can receive any influenza vaccine (egg-based and non-egg based) appropriate
              for age and health status.</li>
            <li>NOTE: Persons with an egg allergy can receive any influenza vaccine (egg-based and non-egg based)
              appropriate for age and health status.</li>

          </ul>

          <p><strong>Contraindications and precautions:</strong></p>
          <li>
            For contraindications and precautions to influenza vaccination, refer to
            <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html" target="_blank" rel="noopener noreferrer">
              IIV4 Appendix</a>,
            <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html" target="_blank" rel="noopener noreferrer">
              LAIV4 Appendix</a>,
            <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html" target="_blank" rel="noopener noreferrer">
              ccIIV4 Appendix</a>, and
            <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html" target="_blank" rel="noopener noreferrer">
              RIV4 Appendix</a>.
          </li>

          <div style={{ width: 'max', height: '1px', backgroundColor: 'black' }}></div>
          <br />

          {/* <div className="section"> */}
          <h3 style={{ color: '#333' }}>Respiratory Syncytial Virus (RSV) Vaccination</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Routine vaccination:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>Pregnant at 32-36 weeks gestation from September through January in most of the
                  continental
                  United States</strong>
                  (NOTE: Providers in jurisdictions with RSV seasonality that differs from most of the continental
                  United
                  States
                  [eg, Alaska, jurisdiction with tropical climate] should follow guidance from public health
                  authorities
                  [eg, CDC, health departments] or regional medical centers on timing of administration based on
                  local RSV
                  seasonality.
                  Refer to the 2024 Child and Adolescent Immunization Schedule for considerations regarding
                  nirsevimab
                  administration to infants): 1 dose RSV vaccine (Abrysvo™).
                  Administer RSV vaccine regardless of previous RSV infection.
                </li>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    Either maternal RSV vaccination or infant immunization with nirsevimab (RSV monoclonal
                    antibody) is
                    recommended to
                    prevent respiratory syncytial virus lower respiratory tract infection in infants.
                  </li>
                </ul>
                <li><strong>All other pregnant persons:</strong> RSV vaccine not recommended.</li>
                <li>There is currently no ACIP recommendation for RSV vaccination in subsequent pregnancies.
                  No data are available to inform whether additional doses are needed in later pregnancies.</li>
              </ul>
            </li>
          </ul>

          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Special situations:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>Age 60 years or older:</strong> Based on shared clinical decision-making, 1 dose RSV
                  vaccine
                  (Arexvy® or Abrysvo™).
                  Persons most likely to benefit from vaccination are those considered to be at increased risk for
                  severe
                  RSV disease
                  (NOTE: Adults age 60 years or older who are at increased risk for severe RSV disease include
                  those with
                  chronic
                  medical conditions such as lung diseases [eg, chronic obstructive pulmonary disease, asthma],
                  cardiovascular diseases
                  [eg, congestive heart failure, coronary artery disease], neurologic or neuromuscular conditions,
                  kidney
                  disorders, liver
                  disorders, hematologic disorders, diabetes mellitus, and moderate or severe immune compromise
                  [either
                  attributable to a
                  medical condition or receipt of immunosuppressive medications or treatment]; those who are
                  considered to
                  be frail;
                  those of advanced age; those who reside in nursing homes or other long-term care facilities; and
                  those
                  with other
                  underlying medical conditions or factors that a health care provider determines might increase
                  the risk
                  of severe
                  respiratory disease). For additional information on shared clinical decision-making for RSV in
                  older
                  adults,
                  refer to <a
                    href="https://www.cdc.gov/vaccines/vpd/rsv/downloads/provider-job-aid-for-older-adults-508.pdf"
                    target="_blank" rel="noopener noreferrer">
                    www.cdc.gov/vaccines/vpd/rsv/downloads/provider-job-aid-for-older-adults-508.pdf</a>.</li>
                <li>For further guidance, refer to <a href="https://www.cdc.gov/mmwr/volumes/72/wr/mm7229a4.htm"
                  target="_blank" rel="noopener noreferrer">www.cdc.gov/mmwr/volumes/72/wr/mm7229a4.htm.</a></li>
              </ul>
            </li>
          </ul>

          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Contraindications and precautions:</strong></li>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                For contraindications and precautions to Respiratory syncytial virus vaccine (RSV), refer to <a
                  href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html" target="_blank" rel="noopener noreferrer"> RSV
                  Appendix.</a>

              </li>
            </ul>
          </ul>

          {/* </div> */}

          {/* <div className="section"> */}
          <h3 style={{ color: '#333' }}>Tetanus, Diphtheria, and Pertussis (Tdap) Vaccination</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              Routine vaccination:
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>Previously did not receive Tdap at or after age 11 years </strong> (NOTE: Tdap
                  administered at age 10 years
                  may be counted as the adolescent dose recommended at age 11-12 years): 1 dose Tdap, then Td or
                  Tdap every 10 years.</li>
              </ul>
            </li>
          </ul>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <strong>Special situations:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>Previously did not receive primary vaccination series for tetanus, diphtheria, or
                  pertussis:</strong>
                  1 dose Tdap followed by 1 dose Td or Tdap at least 4 weeks later, and a third dose of Td or Tdap
                  6 to 12
                  months later
                  (Tdap can be substituted for any Td dose, but preferred as first dose), Td or Tdap every 10
                  years
                  thereafter.
                </li>
                <li><strong>Pregnancy:</strong> 1 dose Tdap during each pregnancy, preferably in early part of
                  gestational
                  weeks 27-36.</li>
                <li><strong>Wound management: </strong>Persons with 3 or more doses of tetanus-toxoid-containing
                  vaccine:
                  For clean and minor
                  wounds, administer Tdap or Td if more than 10 years since last dose of tetanus-toxoid-containing
                  vaccine; for all other wounds, administer Tdap or Td if more than 5 years since last dose of
                  tetanus-toxoid-containing vaccine. Tdap is preferred for persons who have not previously
                  received Tdap
                  or whose Tdap history is unknown. If a tetanus-toxoid-containing vaccine is indicated for a
                  pregnant
                  woman, use Tdap. For detailed information, refer to <a
                    href="https://www.cdc.gov/mmwr/volumes/69/wr/mm6903a5.htm" target="_blank" rel="noopener noreferrer">
                    www.cdc.gov/mmwr/volumes/69/wr/mm6903a5.htm.</a>
                </li>
              </ul>
            </li>
          </ul>

          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Contraindications and precautions:</strong></li>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                For contraindications and precautions to tetanus, diphtheria, and acellular pertussis (Tdap), refer
                to
                <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html" target="_blank" rel="noopener noreferrer"> Tdap
                  Appendix.</a> .
              </li>
            </ul>
          </ul>

          <h2 style={{ color: '#333' }}>Measles, Mumps, and Rubella (MMR) Vaccination</h2>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Routine vaccination:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>
                  No evidence of immunity to measles, mumps, or rubella:
                </strong> 1 dose
                  <ul style={{ paddingLeft: '20px' }}>
                    <li><strong>Evidence of immunity:
                    </strong>Born before 1957 (except for health care personnel, refer below), documentation
                      of receipt of MMR vaccine, laboratory evidence of immunity or disease (diagnosis of
                      disease without laboratory confirmation is not evidence of immunity).</li>
                  </ul>
                </li>
                <li><strong>Special situations:</strong>
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>


                      Pregnancy with no evidence of immunity to rubella: MMR contraindicated during pregnancy;
                      after pregnancy (before discharge from health care facility), 1 dose.</li>
                    <li>Nonpregnant women of childbearing age with no evidence of immunity to rubella: 1 dose.
                    </li>
                    <li>HIV infection with CD4 percentages ≥15% and CD4 count ≥200 cells/mm3 for at least 6
                      months and no evidence of immunity to measles, mumps, or rubella: 2-dose series at least
                      4 weeks apart; MMR contraindicated for HIV infection with CD4 percentage &lt;15% or CD4
                      count &lt;200 cells/mm3.</li>
                    <li> Severe immunocompromising conditions: MMR contraindicated.
                    </li>
                    <li>Students in postsecondary educational institutions, international travelers, and
                      household or close, personal contacts of immunocompromised persons with no evidence of
                      immunity to measles, mumps, or rubella: 2-dose series at least 4 weeks apart if
                      previously did not receive any doses of MMR or 1 dose if previously received 1 dose MMR.
                    </li>
                    <li>In mumps outbreak settings, for information about additional doses of MMR (including 3rd
                      dose of MMR), refer to <a href="https://www.cdc.gov/mmwr/volumes/67/wr/mm6701a7.htm."
                        target="_blank" rel="noopener noreferrer">www.cdc.gov/mmwr/volumes/67/wr/mm6701a7.htm.</a></li>
                    <li>Health care personnel:</li>
                    <ul style={{ paddingLeft: '20px' }}>
                      <li>
                        Born before 1957 with no evidence of immunity to measles, mumps, or rubella:
                        Consider 2-dose series at least 4 weeks apart for measles or mumps or 1 dose for
                        rubella.
                      </li>
                      <li>
                        Born in 1957 or later with no evidence of immunity to measles, mumps, or rubella:
                        2-dose series at least 4 weeks apart for measles or mumps or at least 1 dose for
                        rubella.
                      </li>
                    </ul>
                  </ul>
                </li>
                <li>
                  Contraindications and precautions:
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>
                      For contraindications and precautions to measles, mumps, rubella (MMR), refer to <a
                        href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html" target="_blank" rel="noopener noreferrer">MMR
                        Appendix.</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>


          </ul>
          {/* Varicella Vaccination Section */}
          <h2 style={{ color: '#333' }}>Varicella Vaccination</h2>
          <p><strong>Routine vaccination:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>No evidence of immunity to varicella:</strong> 2-dose series 4-8 weeks apart if previously did
              not receive varicella-containing vaccine (VAR or MMRV for children); if previously received 1 dose
              varicella-containing vaccine, 1 dose at least 4 weeks after first dose.</li>
            <ul style={{ paddingLeft: '20px' }}>
              <li><strong>Evidence of immunity:</strong> US-born before 1980 (except for pregnant women and health
                care
                personnel), documentation of 2 doses varicella-containing vaccine at least 4 weeks apart, diagnosis
                or
                verification of history of varicella or herpes zoster by a health care provider, laboratory evidence
                of
                immunity or disease.</li>
            </ul>
          </ul>
          <p><strong>Special situations:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Pregnancy with no evidence of immunity to varicella:</strong> VAR contraindicated during
              pregnancy; after pregnancy (before discharge from health care facility), 1 dose if previously received 1
              dose varicella-containing vaccine or dose 1 of 2-dose series (dose 2: 4 to 8 weeks later) if previously
              did not receive any varicella-containing vaccine, regardless of whether US-born before 1980.</li>
            <li><strong>Health care personnel with no evidence of immunity to varicella:</strong> 1 dose if previously
              received 1 dose varicella-containing vaccine; 2-dose series 4-8 weeks apart if previously did not
              receive any varicella-containing vaccine, regardless of whether US-born before 1980.</li>
            <li><strong>HIV infection with CD4 percentages ≥15% and CD4 count ≥200 cells/mm³ with no evidence of
              immunity:</strong> Vaccination may be considered (2 doses 3 months apart); VAR contraindicated for
              HIV infection with CD4 percentage &lt;15% or CD4 count &lt;200 cells/mm³.</li>
            <li><strong>Severe immunocompromising conditions:</strong> VAR contraindicated.</li>
          </ul>
          <p><strong>Contraindications and precautions:</strong> For contraindications and precautions to varicella (VAR),
            refer to <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html#appendix-varicella"
              target="_blank" rel="noopener noreferrer">VAR Appendix</a>.</p>

          {/* Zoster Vaccination Section */}
          <h2 style={{ color: '#333' }}>Zoster Vaccination</h2>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Routine vaccination:</strong></li>
            <ul style={{ paddingLeft: '20px' }}>
              <li><strong>Age 50 years or older</strong> (NOTE: Serologic evidence of prior
                varicella is not necessary for zoster vaccination. However, if serologic evidence of varicella
                susceptibility becomes available, providers should follow ACIP guidelines for varicella vaccination
                first. RZV is not indicated for the prevention of varicella, and there are limited data on the use
                of
                RZV in persons without a history of varicella or varicella vaccination): 2-dose series recombinant
                zoster vaccine (RZV, Shingrix) 2-6 months apart (minimum interval: 4 weeks; repeat dose if
                administered
                too soon), regardless of previous herpes zoster or history of zoster vaccine live (ZVL, Zostavax)
                vaccination.</li>
            </ul>
            <ul style={{ paddingLeft: '20px' }}>
              <li><strong>Special situations:</strong></li>
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>Pregnancy:</strong> There is currently no ACIP recommendation for RZV use in
                  pregnancy.
                  Consider
                  delaying RZV until after pregnancy.</li>
                <li><strong>Immunocompromising conditions (including persons with HIV regardless of CD4
                  count):</strong>
                  2-dose series recombinant zoster vaccine (RZV, Shingrix) 2-6 months apart (minimum interval:
                  4
                  weeks;
                  repeat dose if administered too soon). For detailed information, refer to <a
                    href="https://www.cdc.gov/shingles/vaccination/immunocompromised-adults.html"
                    target="_blank" rel="noopener noreferrer">CDC
                    guidelines</a>.</li>
              </ul>

            </ul>
            <ul style={{ paddingLeft: '20px' }}>

              <li><strong>Contraindications and precautions:</strong> For contraindications and precautions to zoster
                recombinant vaccine (RZV), refer to <a
                  href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html#appendix-zoster"
                  target="_blank" rel="noopener noreferrer">RZV Appendix</a>.</li>
            </ul>
          </ul>
          {/* Human Papillomavirus (HPV) Vaccination Section */}
          <h2 style={{ color: '#333' }}>Human Papillomavirus (HPV) Vaccination</h2>
          <p><strong>Routine vaccination:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>All persons up through age 26 years:</strong> 2- or 3-dose series depending on age at initial
              vaccination or condition.</li>
            <li><strong>Age 9-14 years at initial vaccination and received 1 dose or 2 doses less than 5 months
              apart:</strong> 1 additional dose.</li>
            <li><strong>Age 9-14 years at initial vaccination and received 2 doses at least 5 months apart:</strong> HPV
              vaccination series complete, no additional dose needed.</li>
            <li><strong>Age 15 years or older at initial vaccination:</strong> 3-dose series at 0, 1-2 months, 6 months
              (minimum intervals: dose 1 to dose 2: 4 weeks / dose 2 to dose 3: 12 weeks / dose 1 to dose 3: 5 months;
              repeat dose if administered too soon).</li>
            <li><strong>No additional dose recommended</strong> when any HPV vaccine series has been completed using the
              recommended dosing intervals.</li>
          </ul>
          <p><strong>Shared clinical decision-making:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Adults age 27-45 years:</strong> Based on shared clinical decision-making, complete a 2-dose
              series (if initiated age 9-14 years) or 3-dose series (if initiated ≥15 years).</li>
            <li>
              For additional information on shared clinical decision-making for HPV; refer to <a
                href="https://www.cdc.gov/vaccines/hcp/admin/downloads/isd-job-aid-scdm-hpv-shared-clinical-decision-making-hpv.pdf"
                target="_blank" rel="noopener noreferrer">CDC guidelines</a>.</li>
          </ul>
          <p><strong>Special situations:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Age ranges recommended above for routine and catch-up vaccination or shared clinical decision-making
              also apply in special situations.
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>Immunocompromising conditions, including HIV infection:</strong> 3-dose series, even for
                  those
                  who initiate vaccination at age 9 through 14 years.</li>
                <li><strong>Pregnancy:</strong> Pregnancy testing is not needed before vaccination; HPV vaccination
                  is not
                  recommended until after pregnancy; no intervention needed if inadvertently vaccinated while
                  pregnant.
                </li>
              </ul>
            </li>
          </ul>
          <p><strong>Contraindications and precautions:</strong> </p>
          <li>For contraindications and precautions to human
            papillomavirus (HPV) vaccination, refer to <a
              href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html#appendix-hpv" target="_blank" rel="noopener noreferrer">HPV
              Appendix</a>.</li>

          {/* Pneumococcal Vaccination Section */}
          <h3 style={{ color: '#333' }}>Pneumococcal Vaccination</h3>
          <p><strong>Routine vaccination:</strong></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>Age 65 years or older who have:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li><strong>Not previously received a dose of PCV13, PCV15, or PCV20 or whose previous vaccination
                  history is unknown:</strong> 1 dose PCV15 or 1 dose PCV20.
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>
                      If PCV15 is used, administer 1 dose PPSV23 at least 1 year after the PCV15 dose (may use
                      minimum interval of 8 weeks for adults with an immunocompromising condition [NOTE:
                      Immunocompromising conditions include chronic renal failure, nephrotic syndrome,
                      immunodeficiencies, iatrogenic immunosuppression, generalized malignancy, HIV infection,
                      Hodgkin disease, leukemia, lymphoma, multiple myeloma, solid organ transplant,
                      congenital or acquired asplenia, or sickle cell disease or other hemoglobinopathies],
                      cochlear implant, or cerebrospinal fluid leak).
                    </li>
                  </ul>
                </li>

                <li><strong>Previously received only PCV7:</strong> Follow the recommendation above.</li>
                <li><strong>Previously received only PCV13:</strong> 1 dose PCV20 or 1 dose PPSV23.

                  <ul style={{ paddingLeft: '20px' }}>
                    <li><strong>If PCV20 is selected:</strong> Administer at least 1 year after the PCV13 dose.
                    </li>
                    <li>If PPSV23 is selected, administer at least 1 year after the last PCV13 dose (may use
                      minimum interval of 8 weeks for adults with an immunocompromising condition [NOTE:
                      Immunocompromising conditions include chronic renal failure, nephrotic syndrome,
                      immunodeficiencies, iatrogenic immunosuppression, generalized malignancy, HIV infection,
                      Hodgkin disease, leukemia, lymphoma, multiple myeloma, solid organ transplant,
                      congenital or acquired asplenia, or sickle cell disease or other hemoglobinopathies],
                      cochlear implant, or cerebrospinal fluid leak).
                    </li>
                  </ul>
                </li>

                <li><strong>Previously received only PPSV23:</strong> 1 dose PCV15 or 1 dose PCV20. Administer
                  either PCV15 or PCV20 at least 1 year after the last PPSV23 dose.
                  <ul style={{ paddingLeft: '20px' }}>

                    <li>If PCV15 is used, no additional PPSV23 doses are recommended.</li>
                  </ul>
                </li>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    Previously received both PCV13 and PPSV23 but NO PPSV23 was received at age 65 years or
                    older: 1 dose PCV20 or 1 dose PPSV23.
                    <ul style={{ paddingLeft: '20px' }}>
                      <li>If PCV20 is selected, administer at least 5 years after the last pneumococcal
                        vaccine dose.</li>
                      <li>If PPSV23 is selected, refer to dosing schedule at <a
                        href="https://www.cdc.gov/vaccines/vpd/pneumo/downloads/pneumo-vaccine-timing.pdf"
                        target="_blank" rel="noopener noreferrer">cdc.gov/vaccines/vpd/pneumo/downloads/pneumo-vaccine-timing.pdf.</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    Previously received both PCV13 and PPSV23, AND PPSV23 was received at age 65 years or older:
                    Based on shared clinical decision-making, 1 dose of PCV20 at least 5 years after the last
                    pneumococcal vaccine dose.</li>
                  <li>For guidance on determining which pneumococcal vaccines a patient needs and when, please
                    refer to the mobile app which can be downloaded here:
                    <a
                      href="https://www.cdc.gov/vaccines/vpd/pneumo/hcp/pneumoapp.html">www.cdc.gov/vaccines/vpd/pneumo/hcp/pneumoapp.html.</a>"
                  </li>
                </ul>
              </ul>
            </li>
          </ul>
          <ul style={{ paddingLeft: '20px' }}>
            <li><b>Special situations:</b></li>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Age 19-64 years with certain underlying medical conditions or other risk factors who have (NOTE:
                Underlying medical conditions or other risk factors include alcoholism, chronic heart/liver/lung
                disease, chronic renal failure, cigarette smoking, cochlear implant, congenital or acquired
                asplenia, CSF leak, diabetes mellitus, generalized malignancy, HIV, Hodgkin disease,
                immunodeficiency, iatrogenic immunosuppression, leukemia, lymphoma, multiple myeloma, nephrotic
                syndrome, solid organ transplants, or sickle cell disease, or other hemoglobinopathies):</li>
              <ul style={{ paddingLeft: '20px' }}>
                <li>Not previously received a PCV13, PCV15, or PCV20 or whose previous vaccination history is
                  unknown: 1 dose PCV15 or 1 dose PCV20.</li>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>If PCV15 is used, administer 1 dose PPSV23 at least 1 year after the PCV15 dose (may use
                    minimum interval of 8 weeks for adults with an immunocompromising condition [NOTE:
                    Immunocompromising conditions include chronic renal failure, nephrotic syndrome,
                    immunodeficiencies, iatrogenic immunosuppression, generalized malignancy, HIV infection,
                    Hodgkin disease, leukemia, lymphoma, multiple myeloma, solid organ transplant, congenital or
                    acquired asplenia, or sickle cell disease or other hemoglobinopathies], cochlear implant, or
                    cerebrospinal fluid leak).</li>
                </ul>
                <li>Previously received only PCV7: Follow the recommendation.</li>
                <li>Previously received only PCV13: 1 dose PCV20 or 1 dose PPSV23.</li>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>If PCV20 is selected, administer at least 1 year after the PCV13 dose.</li>
                  <li>If PPSV23 is selected, refer to dosing schedule at <a
                    href="https://www.cdc.gov/vaccines/vpd/pneumo/downloads/pneumo-vaccine-timing.pdf">cdc.gov/vaccines/vpd/pneumo/downloads/pneumo-vaccine-timing.pdf</a>.
                  </li>
                </ul>
                <li>Previously received only PPSV23: 1 dose PCV15 or 1 dose PCV20. Administer either PCV15 or PCV20
                  at least 1 year after the last PPSV23 dose.</li>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>If PCV15 is used, no additional PPSV23 doses are recommended.</li>
                </ul>
                <li>Previously received PCV13 and 1 dose of PPSV23: 1 dose PCV20 or 1 dose PPSV23.</li>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>If PCV20 is selected, administer at least 5 years after the last pneumococcal vaccine dose.
                  </li>
                  <li>If PPSV23 is selected, refer to dosing schedule at <a
                    href="https://www.cdc.gov/vaccines/vpd/pneumo/downloads/pneumo-vaccine-timing.pdf">cdc.gov/vaccines/vpd/pneumo/downloads/pneumo-vaccine-timing.pdf</a>.
                  </li>
                </ul>
                <li>For guidance on determining which pneumococcal vaccines a patient needs and when, please refer
                  to the mobile app which can be downloaded here: <a
                    href="https://www.cdc.gov/vaccines/vpd/pneumo/hcp/pneumoapp.html">www.cdc.gov/vaccines/vpd/pneumo/hcp/pneumoapp.html</a>.
                </li>
              </ul>
            </ul>
            <li><b>Contraindications and precautions:</b></li>
            <ul style={{ paddingLeft: '20px' }}>
              <li>For contraindications and precautions to Pneumococcal conjugate (PCV15 and PCV20), refer to <a
                href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html#appendix-PCV"
                target="_blank" rel="noopener noreferrer">PCV
                Appendix;</a>
                and for Pneumococcal polysaccharide (PPSV23), refer to
                <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html#appendix-PPSV23"
                  target="_blank" rel="noopener noreferrer"> PPSV23 Appendix.</a>
              </li>


            </ul>
          </ul>


          <h3 style={{ color: '#333' }}>Hepatitis A vaccination</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <strong>Routine vaccination:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li>Any person who is not fully vaccinated and requests vaccination (identification of risk factor
                  not required): 2-dose series HepA (Havrix 6-12 months apart or Vaqta 6-18 months apart [minimum
                  interval:6 months]) or 3-dose series HepA-HepB (Twinrix at 0,1, 6 months [minimum intervals:
                  dose 1 to dose 2: 4 weeks / dose 2 to dose 3: 5 months]).</li>
              </ul>
            </li>
            <li>
              <strong>Special situations:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li>Any person who is not fully vaccinated and who is at risk for hepatitis A virus infection:
                  2-dose series HepA or 3-dose series HepA-HepB as above. Risk factors for hepatitis A virus
                  infection include:
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>Chronic liver disease (eg, persons with hepatitis B, hepatitis C, cirrhosis, fatty liver
                      disease, alcoholic liver disease, autoimmune hepatitis, alanine aminotransferase [ALT]
                      or
                      aspartate aminotransferase [AST] level greater than twice the upper limit of normal).
                    </li>
                    <li>HIV infection.</li>
                    <li>Men who have sex with men.</li>
                    <li>Injection or noninjection drug use.</li>
                    <li>Persons experiencing homelessness.</li>
                    <li>Work with hepatitis A virus in research laboratory or with nonhuman primates with
                      hepatitis A
                      virus infection.</li>
                    <li>Travel in countries with high or intermediate endemic hepatitis A (HepA-HepB [Twinrix]
                      may be
                      administered on an accelerated schedule of 3 doses at 0, 7, and 21 to 30 days, followed
                      by a
                      booster dose at 12 months).</li>
                    <li>Close, personal contact with international adoptee (eg, household or regular
                      babysitting) in
                      first 60 days after arrival from country with high or intermediate endemic hepatitis A
                      (administer dose 1 as soon as adoption is planned, at least 2 weeks before adoptee's
                      arrival).
                    </li>
                    <li>Pregnancy if at risk for infection or severe outcome from infection during pregnancy.
                    </li>
                    <li>Settings for exposure, including health care settings targeting services to injection or
                      noninjection drug users or group homes and nonresidential day care facilities for
                      developmentally disabled persons (individual risk factor screening not required).</li>
                  </ul>
                </li>

              </ul>
            </li>
            <li>
              <strong>Contraindications and precautions:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li>For contraindications and precautions to hepatitis A (HepA) vaccination, refer to
                  <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html#appendix-hepa"
                    target="_blank" rel="noopener noreferrer">HepA Appendix.</a>
                </li>
              </ul>
            </li>
          </ul>


          <h3 style={{ color: '#333' }}>Hepatitis B vaccination</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <strong>Routine vaccination:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  <strong>Age 19 through 59 years:</strong> Complete a 2- or 3-, or 4-dose series.
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>2-dose series only applies when 2 doses of Heplisav-B (NOTE: Heplisav-B and
                      PreHevbrio are not recommended in pregnancy due to lack of safety data in
                      pregnant persons) are used at least 4 weeks apart.</li>
                    <li>3-dose series Engerix-B, PreHevbrio (NOTE: Heplisav-B and PreHevbrio are not
                      recommended in pregnancy due to lack of safety data in pregnant persons), or
                      Recombivax HB at 0, 1, 6 months (minimum intervals: dose 1 to dose 2: 4 weeks /
                      dose 2 to dose 3: 8 weeks / dose 1 to dose 3: 16 weeks).</li>
                    <li>3-dose series HepA-HepB (Twinrix at 0, 1, 6 months [minimum intervals: dose 1 to
                      dose 2: 4 weeks / dose 2 to dose 3: 5 months]).</li>
                    <li>4-dose series HepA-HepB (Twinrix) accelerated schedule of 3 doses at 0, 7, and
                      21 to 30 days, followed by a booster dose at 12 months.</li>
                  </ul>
                </li>
                <li>
                  <strong>Age 60 years or older without</strong> known risk factors for hepatitis B virus
                  infection may complete a HepB vaccine series.
                </li>
                <li>
                  <strong>Age 60 years or older with</strong> known risk factors for hepatitis B virus
                  infection
                  <strong>should</strong> complete a HepB vaccine series.
                </li>
                <li>
                  <strong>Any adult age 60 years of age or older</strong> who requests HepB vaccination
                  should receive a HepB vaccine series.
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>
                      Risk factors for hepatitis B virus infection include:
                      <ul style={{ paddingLeft: '20px' }}>
                        <li>Chronic liver disease (eg, persons with hepatitis C, cirrhosis, fatty
                          liver disease, alcoholic liver disease, autoimmune hepatitis, alanine
                          aminotransferase [ALT] or aspartate aminotransferase [AST] level greater
                          than twice upper limit of normal).</li>
                        <li>HIV infection.</li>
                        <li>Sexual exposure risk (eg, sex partners of hepatitis B surface antigen
                          [HBsAg]-positive persons; sexually active persons not in mutually
                          monogamous relationships; persons seeking evaluation or treatment for a
                          sexually transmitted infection; men who have sex with men).</li>
                        <li>Current or recent injection drug use.</li>
                        <li>Percutaneous or mucosal risk for exposure to blood (eg, household
                          contacts of HBsAg-positive persons; residents and staff of facilities
                          for developmentally disabled persons; health care and public safety
                          personnel with reasonably anticipated risk for exposure to blood or
                          blood-contaminated body fluids; persons on maintenance dialysis,
                          including in-center or home hemodialysis and peritoneal dialysis, and
                          persons who are predialysis; patients with diabetes [NOTE:
                          <strong>Age 60 years or older with diabetes:</strong> Based on shared
                          clinical decision making, 2-, 3-, or 4-dose series as above]).
                        </li>
                        <li>Incarceration.</li>
                        <li>Travel in countries with high or intermediate endemic hepatitis B.</li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Special situations:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  <strong>Patients on dialysis:</strong> Complete a 3- or 4-dose series.
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>3-dose series Recombivax HB at 0, 1, 6 months (NOTE: Use Dialysis Formulation 1
                      mL = 40 mcg).</li>
                    <li>4-dose series Engerix-B at 0, 1, 2, and 6 months (NOTE: Use 2 mL dose instead of
                      the normal adult dose of 1 mL).</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Contraindications and precautions:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                <li>For contraindications and precautions to hepatitis B (HepB) vaccination, refer to HepB
                  Appendix.</li>
              </ul>
            </li>
          </ul>
          <h3 style={{ color: '#333' }}>§§ Meningococcal vaccination</h3>
          <ul style={{ paddingLeft: '20px' }}>

            <li>
              Special situations for MenACWY:
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  Anatomical or functional asplenia (including sickle cell disease), HIV infection, persistent
                  complement component deficiency, complement inhibitor (eg, eculizumab, ravulizumab) use: 2-dose
                  series MenACWY (Menveo or MenQuadfi) at least 8 weeks apart and revaccinate every 5 years if
                  risk remains.
                </li>
                <li>
                  Travel in countries with hyperendemic or epidemic meningococcal disease, or microbiologists
                  routinely exposed to Neisseria meningitidis: 1 dose MenACWY (Menveo or MenQuadfi) and
                  revaccinate every 5 years if risk remains.
                </li>
                <li>
                  First-year college students who live in residential housing (if not previously vaccinated at age
                  16 years or older) or military recruits: 1 dose MenACWY (Menveo or MenQuadfi).
                </li>
                <li>
                  For MenACWY booster dose recommendations for groups listed under "Special situations" and in an
                  outbreak setting (eg, in community or organizational settings or among men who have sex with
                  men) and additional meningococcal vaccination information, refer to <a
                    href="https://www.cdc.gov/mmwr/volumes/69/rr/rr6909a1.htm">www.cdc.gov/mmwr/volumes/69/rr/rr6909a1.htm</a>.
                </li>
              </ul>
            </li>
            <li>
              Shared clinical decision-making for MenB:
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  Adolescents and young adults age 16-23 years (age 16-18 years preferred) not at increased risk
                  for meningococcal disease: Based on shared clinical decision-making, 2-dose series MenB-4C
                  (Bexsero) at least 1 month apart or 2-dose series MenB-FHbp (Trumenba) at 0, 6 months (if dose 2
                  was administered less than 6 months after dose 1, administer dose 3 at least 4 months after dose
                  2); MenB-4C and MenB-FHbp are not interchangeable (use same product for all doses in series).
                </li>
                <li>
                  For additional information on shared clinical decision-making for MenB, refer to <a
                    href="https://www.cdc.gov/vaccines/hcp/admin/downloads/isd-job-aid-scdm-mening-b-shared-clinical-decision-making.pdf">www.cdc.gov/vaccines/hcp/admin/downloads/isd-job-aid-scdm-mening-b-shared-clinical-decision-making.pdf</a>.
                </li>
              </ul>
            </li>
            <li>
              Special situations for MenB:
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  Anatomical or functional asplenia (including sickle cell disease), persistent complement
                  component deficiency, complement inhibitor (eg, eculizumab, ravulizumab) use, or microbiologists
                  routinely exposed to Neisseria meningitidis: 2-dose primary series MenB-4C (Bexsero) at least 1
                  month apart or 3-dose primary series MenB-FHbp (Trumenba) at 0, 1-2, 6 months (if dose 2 was
                  administered at least 6 months after dose 1, dose 3 not needed; if dose 3 is administered
                  earlier than 4 months after dose 2, a fourth dose should be administered at least 4 months after
                  dose 3); MenB-4C and MenB-FHbp are not interchangeable (use same product for all doses in
                  series); 1 dose MenB booster 1 year after primary series and revaccinate every 2-3 years if risk
                  remains.
                </li>
                <li>
                  Pregnancy: Delay MenB until after pregnancy unless at increased risk and vaccination benefits
                  outweigh potential risks.
                </li>
                <li>
                  For MenB booster dose recommendations for groups listed under "Special situations" and in an
                  outbreak setting (eg, in community or organizational settings and among men who have sex with
                  men) and additional meningococcal vaccination information, refer to <a
                    href="https://www.cdc.gov/mmwr/volumes/69/rr/rr6909a1.htm">www.cdc.gov/mmwr/volumes/69/rr/rr6909a1.htm</a>.
                </li>
                <li>
                  NOTE: MenB vaccines may be administered simultaneously with MenACWY vaccines if indicated, but
                  at a different anatomic site, if feasible.
                </li>
                <li>
                  Adults may receive a single dose of Penbraya™ as an alternative to separate administration of
                  MenACWY and MenB when both vaccines would be given on the same clinic day. For adults not at
                  increased risk, if Penbraya™ is used for dose 1 MenB, MenB-FHbp (Trumenba) should be
                  administered for dose 2 MenB. For adults at increased risk of meningococcal disease, Penbraya™
                  may be used for additional MenACWY and MenB doses (including booster doses) if both would be
                  given on the same clinic day and at least 6 months have elapsed since most recent Penbraya™
                  dose.
                </li>
              </ul>
            </li>

            <li>
              Contraindications and precautions:
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  For contraindications and precautions to meningococcal ACWY (MenACWY) [MenACWY-CRM (Menveo);
                  MenACWY-D (Menactra); MenACWY-TT (MenQuadfi)], refer to
                  <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html#appendix-MenACWY"
                    target="_blank" rel="noopener noreferrer"> MenACWY Appendix.</a>

                </li>
                <li>
                  For contraindications and precautions to meningococcal B (MenB) [MenB-4C (Bexsero); MenB-FHbp
                  (Trumenba)], refer to
                  <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html#appendix-MenB"
                    target="_blank" rel="noopener noreferrer"> MenB Appendix.</a>

                </li>
              </ul>
            </li>
          </ul>



          <h3 style={{ color: '#333' }}>¥¥ <b><i>Haemophilus influenzae</i> type b vaccination</b></h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Special situations:
              <ul style={{ paddingLeft: '20px' }}>
                <li>Anatomical or functional asplenia (including sickle cell disease): 1 dose if previously did not
                  receive Hib; if elective splenectomy, 1 dose, preferably at least 14 days before splenectomy.
                </li>
                <li>Hematopoietic stem cell transplant (HSCT): 3-dose series 4 weeks apart starting 6-12 months
                  after successful transplant, regardless of Hib vaccination history.</li>
              </ul>
            </li>
            <li>Contraindications and precautions:
              <ul style={{ paddingLeft: '20px' }}>
                <li>For contraindications and precautions to <i>Haemophilus influenzae</i> type b (Hib) vaccination,
                  refer to <a href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html#appendix-hib">Hib
                    Appendix</a>.</li>
              </ul>
            </li>
          </ul>

          <h3 style={{ color: '#333' }}>## <b>Mpox vaccination</b></h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Special situations:
              <ul style={{ paddingLeft: '20px' }}>
                <li><b>Any person at risk for Mpox infection</b>: 2-dose series, 28 days apart.</li>
                <li><b>Risk factors for Mpox infection include:</b>
                  <ul style={{ paddingLeft: '20px' }}>
                    <li>Persons who are gay, bisexual, and other MSM, transgender or nonbinary people who in the
                      past 6 months have had:
                      <ul style={{ paddingLeft: '20px' }}>
                        <li>A new diagnosis of at least 1 sexually transmitted disease.</li>
                        <li>More than 1 sex partner.</li>
                        <li>Sex at a commercial sex venue.</li>
                        <li>Sex in association with a large public event in a geographic area where Mpox
                          transmission is occurring.</li>
                      </ul>
                    </li>
                    <li>Persons who are sexual partners of the persons described above.</li>
                    <li>Persons who anticipate experiencing any of the situations described above.</li>
                  </ul>
                </li>
                <li><b>Pregnancy</b>: There is currently no ACIP recommendation for Jynneos use in pregnancy due to
                  lack of safety data in pregnant persons. Pregnant persons with any risk factor described above
                  may receive Jynneos.</li>
                <li><b>Health care personnel</b>: Except in rare circumstances (eg, no available personal protective
                  equipment), health care personnel who do not have any of the sexual risk factors described above
                  should not receive Jynneos.</li>
                <li>For detailed information, refer to: <a
                  href="https://www.cdc.gov/vaccines/acip/meetings/downloads/slides-2023-10-25-26/04-MPOX-Rao-508.pdf">www.cdc.gov/vaccines/acip/meetings/downloads/slides-2023-10-25-26/04-MPOX-Rao-508.pdfContrain
                  dications and Precautions</a>.</li>
              </ul>
            </li>
            <li>Contraindications and precautions:
              <ul style={{ paddingLeft: '20px' }}>
                <li>For contraindications and precautions to Mpox, refer to <a
                  href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult-conditions.html#appendix-mpox">Mpox
                  Appendix</a>.</li>
              </ul>
            </li>
          </ul>

          <p>†† Vaccinate after pregnancy, if indicated.</p>

          <div style={{ width: 'max', height: '1px', backgroundColor: 'rgb(190, 184, 184)' }}></div>
          <br />
          <footer>
            <p>Information sourced from uptodate.com</p>
          </footer>

        </div>
      </div>
    </div>
  );
};

export default AdultImmunizationSchedule; 